export const AzureTenantExchangeStateEnum = {
    AWAITING_NCACHE_AUTHORIZATION: "awaiting_ncache_authorization",
    AWAITING_GUEST_USER_ACCEPTANCE: "awaiting_guest_user_acceptance",
    COMPLETED: "completed"
} as const;

export const AddTrustedTenantPathEnum = {
    ADD_TENANT: "add_tenant",
    ADD_USER: "add_user"
} as const;